module.exports = __webpack_public_path__ + "static/media/30pic.1e36bd57.jpg";